import styled from 'styled-components';

import { Loading } from 'ui/illustrations';
import { spacing } from 'ui/theme';

import { RECENT_EVENTS_ROW_COUNT } from '../constants';
import { PlaceholderListItem } from './PlaceholderListItem';

const displayText = {
  loadingMessage: 'Updating...',
};

const Spinner = styled(Loading)`
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  animation-name: spin;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: steps(8);
  margin-bottom: ${spacing.quarter};
`;

export const RefetchSpinner = () => (
  <PlaceholderListItem $rowSpan={RECENT_EVENTS_ROW_COUNT} data-test="refetch-spinner">
    <Spinner />
    <div>{displayText.loadingMessage}</div>
  </PlaceholderListItem>
);
